import { HtmlTable } from '../../../CommonComponents/OPL/HtmlTable/HtmlTable';
import styled from '../../../theme/theme';

interface StyledHtmlTableProps {
  isEmbeddedMobile: boolean;
}

export const StyledHtmlTable = styled(HtmlTable)<StyledHtmlTableProps>(
  ({ theme, isEmbeddedMobile }) => ({
    thead: {
      display: 'none',
    },

    td: {
      display: 'none',

      '&:nth-child(1), &:nth-child(4)': {
        display: 'table-cell',
      },
    },

    [`@media only screen and (min-width: ${isEmbeddedMobile ? theme.breakpoints[0] : '0px'})`]: {
      thead: {
        display: 'table-header-group',
      },

      td: {
        display: 'table-cell',

        '&:nth-child(4)': {
          display: 'none',
        },
      },
    },
  }),
);
